import { useMutation } from '@tanstack/react-query'
import { phoneVerificationQueryKeys } from 'src/queries/queries.constants'

import {
  SendPhoneCodeRequest,
  SendPhoneCodeResponse,
  VerifyPhoneCodeRequest,
  VerifyPhoneCodeResponse,
} from '../network/phoneVerification.models'
import {
  postSendPhoneCode,
  postVerifyPhoneCode,
} from '../network/phoneVerification.network'
import { OptionalMutationOptions } from './queries.utils'

export const useSendPhoneCode = (
  options?: OptionalMutationOptions<
    SendPhoneCodeResponse,
    SendPhoneCodeRequest
  >,
) => {
  return useMutation({
    mutationFn: (data: SendPhoneCodeRequest) => postSendPhoneCode(data),
    mutationKey: phoneVerificationQueryKeys.sendCode(),
    ...options,
  })
}

export const useVerifyPhoneCode = (
  options?: OptionalMutationOptions<
    VerifyPhoneCodeResponse,
    VerifyPhoneCodeRequest
  >,
) => {
  return useMutation({
    mutationFn: (data: VerifyPhoneCodeRequest) => postVerifyPhoneCode(data),
    mutationKey: phoneVerificationQueryKeys.verifyCode(),
    ...options,
  })
}
